import { createFileRoute, Link, Navigate, Outlet, useRouterState } from "@tanstack/react-router";
import { Shell } from "@/components/Shell";
import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/borrower")({
  component: BorrowerLayout,
});

function BorrowerLayout() {
  const { session, initializing } = useAuth();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const isCallback = path.includes("repayment-callback") || path.includes("score-callback");

  // Payment callbacks must render even if the session is still loading or was
  // dropped after returning from Paystack — otherwise finalize never runs.
  if (isCallback) {
    if (initializing) {
      return (
        <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">
          Loading…
        </div>
      );
    }
    return <Outlet />;
  }

  if (initializing) {
    return (
      <Shell>
        <div className="mx-auto max-w-md py-24 text-center text-sm text-muted-foreground">Loading…</div>
      </Shell>
    );
  }
  if (!session) return <Navigate to="/login" />;
  if (session.kind !== "borrower") {
    return (
      <Shell>
        <div className="mx-auto max-w-md py-24 text-center">
          <h1 className="font-display text-2xl">Not a borrower account</h1>
          <p className="mt-2 text-muted-foreground text-sm">You're signed in as an admin.</p>
          <Link to="/admin" className="text-gold mt-4 inline-block">Go to admin →</Link>
        </div>
      </Shell>
    );
  }

  return (
    <Shell variant="borrower">
      <Outlet />
    </Shell>
  );
}
